import { useTranslation } from 'react-i18next'
import { CheckIcon, SpinnerIcon } from './icons'

interface SaveBarProps {
	isDirty: boolean
	savedRecently: boolean
	isPending: boolean
	validationError: string | null
	hasGenericError: boolean
	onSave: () => void
}

export function SaveBar({ isDirty, savedRecently, isPending, validationError, hasGenericError, onSave }: SaveBarProps) {
	const { t } = useTranslation('common')

	return (
		<div className="sticky -bottom-10 py-4 bg-white flex flex-col items-start gap-4">
			<button
				type="button"
				onClick={onSave}
				disabled={isPending || !isDirty}
				className="flex items-center gap-2 rounded-lg bg-brand-600 px-5 py-2.5 text-sm font-medium text-white hover:bg-brand-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
			>
				{isPending
					? (
						<>
							<SpinnerIcon />
							{t('account.availability.save.saving')}
						</>
					)
					: savedRecently
					? (
						<>
							<CheckIcon />
							{t('account.availability.save.saved')}
						</>
					)
					: t('account.availability.save.button')}
			</button>
			{isDirty && !isPending && !savedRecently
				? (
					<span className="text-xs text-grey-400">
						{t('account.availability.save.unsaved_changes')}
					</span>
				)
				: null}
			{validationError != null ? <span className="text-xs text-red-500">{validationError}</span> : null}
			{hasGenericError
				? (
					<span className="text-xs text-red-500">
						{t('account.availability.save.error_generic')}
					</span>
				)
				: null}
		</div>
	)
}
